import { dayjs } from '@mobi/utils/date'

export function todayAsAwst(): Date {
  const date = dayjs.utc(new Date()).utcOffset(8).toDate()
  date.setHours(0, 0, 0, 0)
  return date
}

export function now(): number {
  return new Date().getTime()
}
